module.exports = __webpack_public_path__ + "static/img/web_7_activities.8d6ca572.jpg";